import { create } from 'zustand';

/**
 * Licence state of this Firmio instance as the API reports it. Set when any
 * request answers INSTANCE_SUSPENDED or when the boot probe of
 * /api/public/instance says so; App then renders SuspendedPage instead of the
 * app. Deliberately not persisted: every load asks the server again.
 */
interface InstanceState {
  suspended: boolean;
  message: string | null;
  setSuspended: (message: string | null) => void;
  clearSuspended: () => void;
}

export const useInstanceStore = create<InstanceState>((set) => ({
  suspended: false,
  message: null,
  setSuspended: (message) => set({ suspended: true, message }),
  clearSuspended: () => set({ suspended: false, message: null }),
}));
